<template>
	<div>
		
		<!-- confirmation dialog box -->
		<v-dialog v-model="dialog.flag" width="400" >
			<v-card>
				<v-card-title
				class="headline flex-column lighten-2"
				primary-title
				>
				<v-icon size="5rem" color="warning" >
					mdi-help-circle-outline
				</v-icon>
				{{$lang.ARE_YOU_SURE}}?
			</v-card-title >
			<v-card-text class="flex-column text-center mb-5 ">
				{{$lang.ARE_YOU_SURE_DELETE}}
				<span class="fw-bold"> {{dialog.product_name}}</span>?
			</v-card-text>

			<v-divider></v-divider>
			<v-card-actions class="text-center">
				<v-spacer></v-spacer>
				<v-btn color="light" width="80" class="fw-bold" @click="dialog.flag=false">	
					No 
				</v-btn>	
				<v-btn color="primary" width="80" class="fw-bold ml-5" :loading="btn_loading"  @click="deleteProduct">	
					Yes
				</v-btn>	
				<v-spacer></v-spacer>
			</v-card-actions>
		</v-card>
	</v-dialog>

</div>
</template>
<script>
export default{
	props:['dialog'],
	data(){
		return{
			btn_loading:false,
		}
	},
	methods:{
		deleteProduct(){
			const self=this
			let params={
				id:this.dialog.product_id,
			};
			self.btn_loading=true;
			const successHandler = (response) => {
				self.dialog.product_id="";
				self.dialog.product_name="";
				self.dialog.flag=false;
				this.$emit("update-product-list");
			};
			const finallyHandler = () => {
				self.btn_loading=false
			};
			self.request_GET( self,self.$urls.DELETE_PRODUCT,params,successHandler,null,null,finallyHandler)


		}
	}
}

</script>